//let selectedEnv = "Local";
//let selectedEnv = "Develop";
//let selectedEnv = "Staging";
//let selectedEnv = "StagingUpgrade";
let selectedEnv = "Buchservice";
//let selectedEnv = "MPv2";
//let selectedEnv = "Bookseller";

let def = {
    nbCoreApiUrl: 'http://localhost:62545',
    EnableModuleRestriction: true,
    EnableOnlineLicenses: true,
    EnableSearchByClassifications: true,
    PdfDownload: true,
    GraphQlEnabled: true
};

let output = def;

if (selectedEnv == "Local") {
    // Local
    output = {
        nbCoreApiUrl: 'http://localhost:62545',
        EnableModuleRestriction: true,
        EnableOnlineLicenses: true,
        EnableSearchByClassifications: true,
        PdfDownload: true,
        GraphQlEnabled: true
    }
}
else if (selectedEnv == "Develop") {
    // Develop
    output = {
        nbCoreApiUrl: 'https://devsearchapi.mynewbooks.biz',
        EnableModuleRestriction: true,
        EnableOnlineLicenses: true,
        EnableSearchByClassifications: true,
        PdfDownload: false,
        GraphQlEnabled: true
    }
}
else if (selectedEnv == "Staging") {
    // Staging
    output = {
        nbCoreApiUrl: 'https://elasticsearch.mynewbooks.biz',
        EnableModuleRestriction: true,
        EnableOnlineLicenses: true,
        EnableSearchByClassifications: true,
        PdfDownload: false,
        GraphQlEnabled: true
    }
}
else if (selectedEnv == "StagingUpgrade") {
    // StagingUpgrade
    output = {
        nbCoreApiUrl: 'https://elasticsearchupgrade.mynewbooks.biz',
        EnableModuleRestriction: true,
        EnableOnlineLicenses: true,
        EnableSearchByClassifications: true,
        PdfDownload: false,
        GraphQlEnabled: true
    }
}
else if (selectedEnv == "Buchservice") {
    // Buchservice
    output = {
        nbCoreApiUrl: 'https://live-elasticsearch.mynewbooks.biz',
        EnableModuleRestriction: true,
        EnableOnlineLicenses: true,
        EnableSearchByClassifications: true,
        PdfDownload: false,
        GraphQlEnabled: true
    }
}
else if (selectedEnv == "MPv2") {
    // Multi portal v2
    output = {
        nbCoreApiUrl: 'https://search-v2.mynewbooks.biz',
        EnableModuleRestriction: false,
        EnableOnlineLicenses: false,
        EnableSearchByClassifications: false,
        PdfDownload: false,
        GraphQlEnabled: true
    }
}
else if (selectedEnv == "Bookseller") {
    // Multi portal v2
    output = {
        nbCoreApiUrl: 'https://demo-api-stg.mynewbooks.biz',
        EnableModuleRestriction: false,
        EnableOnlineLicenses: false,
        EnableSearchByClassifications: false,
        PdfDownload: true,
        GraphQlEnabled:true
    }
}

export default output;

// ToDo : try to make it in build mode not in the runtime mode
// As we have multiple environment on the live machine

// var env = process.env.NODE_ENV.trim();

// console.log(process.env.NODE_ENV);

// var config = {
//   development: require('./development'),
//   'dev-server': require('./dev-server'),
//   staging: require('./staging'),
//   production: require('./production'),
//   'production-v2': require('./production-v2')
// }

// module.exports = config[env]